export default "__VITE_ASSET__08a4c4ec__"